import { installBanners } from '@/app/common/biff/biffLoader.ts';

/**
 * Slot ids agreed with the Media team; the containers live in adSlots.tsx and AdsFooter.tsx. The rooms ad
 * (RoomsAd.tsx) is not listed here: it installs itself once the rooms are on the page.
 */
export const HOTEL_DETAIL_POSITIONS = {
  GPT: ['div-gpt-ad-external_right2', 'div-gpt-ad-external_right3', 'div-gpt-ad-bottom3'],
  AFS: ['afs-details-bottom'],
};

const AFS_OPTIONS = { number: 3 };

export const installHotelDetailBanners = (): void => {
  installBanners({ elements: HOTEL_DETAIL_POSITIONS.GPT, provider: 'googleDFP' });
  installBanners({ elements: HOTEL_DETAIL_POSITIONS.AFS, provider: 'googleAFS', options: AFS_OPTIONS });
};
